export default ({ request }) => ({
    mrpOtherStockOutListApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/out/list',
        method: 'post',
        data,
      })
    },
    mrpOtherStockOutSaveApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/out/save',
        method: 'post',
        data,
      })
    },
    mrpOtherStockOutAuditApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/out/audit',
        method: 'post',
        data,
      })
    },
    mrpOtherStockOutDetailApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/out/detail',
        method: 'post',
        data,
      })
    },
    mrpOtherStockOutDelApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/out/del',
        method: 'post',
        data,
      })
    },
  })
  